import $  from 'jquery';
import Reflux from 'reflux';
import Tracking from 'medscape/tracking';

const FormActions = Reflux.createActions({
  "reset": {},
  "post": { children: ['completed', 'failed'] }
});

const Helpers = {
  getPostData: (postState) => {
    let postData = {
      "workflow":"medscape_ba_sharethis",
      "toEmailId":[],
      "params":{
        "senderName": postState.senderName,
        "senderEmail": postState.senderEmail,
        "pubName":"",
        "subject":postState.subject,
        "linkURL":postState.linkUrl,
        "contentTitle":postState.contentTitle,
        "message":postState.message,
        "pubDate":""
      }
    }
    if(postState.recipient.length>0) {
      postData.toEmailId.push(postState.recipient);
    }
    if(postState.isCopySender) {
      postData.toEmailId.push(postState.senderEmail);
    }
    return postData;
  }
}
FormActions.post.listen(function(postState) {
  let postUrl = `${window.medscape.config.apiHost.replace("www","api")}/servicegateway/v2/auth/notificationservice/emailthis`;
  let postData = Helpers.getPostData(postState);
  $.ajax({
    type: 'POST',
    contentType: "application/json",
    dataType: "json",
    processData: false,
    url: postUrl,
    data: JSON.stringify(postData),
    xhrFields: {
      withCredentials: true
    },
    statusCode: {
      '404': () => {
        console.error('404');
      },
      '403': () => {
        console.error("403 Response ",window.medscape.config.env);
        if(window.medscape.config.env=='localhost') {
          //console.log("In Localhost");
          //this.completed({"messages":["successs"]});
        }
      }
    }
  }).then(
  (data) => {
    this.completed(data);
  },this.failed);
  Tracking.track("share-email_submit");
});
export default FormActions;



// WEBPACK FOOTER //
// ./medscape_modules/email-modal/form/actions.js